import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Dictionary } from '@feedyou/schema'
import { VisitStatisticsScopeSettings } from '../../features/visitStatistics/types'
import { DEFAULT_VISIT_STATISTICS_SCOPE_SETTINGS } from '../../features/visitStatistics/constants'

export type VisitStatisticsSlice = {
  showVisitStatistics: boolean
  dateFrom: string | undefined
  dateTo: string | undefined
  scopeSettingsPerView: Dictionary<string, VisitStatisticsScopeSettings>
}

export const initialState: VisitStatisticsSlice = {
  showVisitStatistics: false,
  dateFrom: undefined,
  dateTo: undefined,
  scopeSettingsPerView: {}
}

const visitStatisticsSlice = createSlice({
  name: 'visitStatistics',
  initialState,
  reducers: {
    setVisitStatisticsVisibility: (state, action: PayloadAction<boolean>) => {
      state.showVisitStatistics = action.payload
    },

    setDateFrom: (state, action: PayloadAction<string | undefined>) => {
      state.dateFrom = action.payload || undefined // || just in case `null` or '' makes its way through
    },

    setDateTo: (state, action: PayloadAction<string | undefined>) => {
      state.dateTo = action.payload || undefined // || just in case `null` or '' makes its way through
    },

    updateScopeSettings: (
      state,
      action: PayloadAction<{ key: string; settingsPatch: Partial<VisitStatisticsScopeSettings> }>
    ) => {
      const { key, settingsPatch } = action.payload

      if (!state.scopeSettingsPerView[key]) {
        state.scopeSettingsPerView[key] = DEFAULT_VISIT_STATISTICS_SCOPE_SETTINGS
      }

      state.scopeSettingsPerView[key] = {
        ...state.scopeSettingsPerView[key]!,
        ...settingsPatch
      }
    }
  }
})

export const visitStatisticsActions = visitStatisticsSlice.actions
export const visitStatisticsReducer = visitStatisticsSlice.reducer
